export const getSelectedReportPeriod = state =>
    state.reportPeriod.selectedPeriod



// WEBPACK FOOTER //
// ./src/redux/selectors/reportPeriod/getSelectedReportPeriod.js